import { takeUntil } from 'rxjs/operators';
import { UnsubscribeOnDestroy } from 'src/app/_helpers/unsubscribe-on-destroy';
import { Component, OnInit } from "@angular/core";
import { AuthService } from "../_services/auth.service";
import { TokenStorageService } from "../_services/token-storage.service";
import { Router, ActivatedRoute } from "@angular/router";
import { ServicioGeneral } from "../_services/servicio-general.service";
import { UntypedFormBuilder, UntypedFormGroup, Validators, UntypedFormControl, FormGroup, FormControl } from "@angular/forms";
import { UrlService } from "../_services/urlService";
import { environment } from 'src/environments/environment';
import { UserService } from "../_services/user.service";
import { NotificationService } from "../_services/notification.service";
import { RaizComponent } from "../raiz/raiz.component";
import { ConfirmarCorreoService } from "../_services/confirmar-correo.service";
import { ClaveService } from "../_services/clave.service";
import { SamlRequest } from "src/app/model/samltoken";
import { NotificationI18nService } from '../core/util/notification-i18n.service';
@Component({
  selector: "app-login",
  templateUrl: "./login.component.html",
  styleUrls: ["./login.component.css"],
})
export class LoginComponent extends UnsubscribeOnDestroy implements OnInit {
  form: FormGroup = new FormGroup({
    email: new FormControl("", [Validators.required, Validators.pattern("^[a-z0-9._%+-]+@[a-z0-9.-]+\.[a-z]{2,4}$")]),
    password: new FormControl("", [Validators.required, Validators.minLength(6)]),
    totpkey: new FormControl(""),
  });

  form2: FormGroup = new FormGroup({
    totpkey: new FormControl("", [Validators.required, Validators.minLength(6)])
  });

  isLoggedIn = false;
  isLoginFailed = false;
  errorMessage = "";
  midata: string[] = [];
  tfaFlag: boolean = false;
  tfa: string = null;
  userRoles: any = [];
  submitted = false;
  loading = false;
  returnUrl: string;
  errorTfa: boolean;
  check2fa: boolean = false;
  errorQR: boolean;
  tfActivated: boolean;
  resetQR: boolean = false;
  resetedQR: boolean = false;
  environment: string = environment.environment;
  previousUrl: string = '';
  correoNoConfirmado: boolean = false;
  constructor(
    private authService: AuthService,
    private tokenStorage: TokenStorageService,
    private route: ActivatedRoute,
    private router: Router,
    private userService: UserService,
    private formBuilder: UntypedFormBuilder,
    private urlService: UrlService,
    private _notificationI18n: NotificationI18nService,
    private raiz: RaizComponent,
    private _confirmarCorreo: ConfirmarCorreoService,
    private _claveservice: ClaveService,
  ) {
    super();
  }

  ngOnInit(): void {
    this.redireccion();
    if (this.route.snapshot.queryParamMap['params']['route']) {
      this.returnUrl = this.route.snapshot.queryParamMap['params']['route'];
      localStorage.setItem('nextUrl', this.returnUrl);
    }
  }





  onSubmit(): any {
    this.submitted = true;

    if (this.form.get('email').hasError('pattern')) {
      this._notificationI18n.warning('NOTIFICATION.MESSAGE.EL_EMAIL_NO_ES_VALIDO', 5000);
      return false;
    }
    if (this.form.get('password').hasError('minlength')) {
      this._notificationI18n.warning('NOTIFICATION.MESSAGE.LA_CONTRASENA_DEBE_CONTENER_6_CARACTERES', 5000);
      return false;
    }
    if (!this.form.valid) {
      this._notificationI18n.warning('NOTIFICATION.MESSAGE.RELLENE_TODOS_LOS_CAMPOS_POR_FAVOR', 5000);
    } else {
      this.authService.login(this.form.controls['email'].value, this.form.controls['password'].value, this.form.controls['totpkey'].value)
        .pipe(takeUntil(this.destroy$))
        .subscribe({
        next: async (data) => {

          if (data['2faEnabled'] === "true" && data['tfa'] === "disabled") {
            this.tokenStorage.saveToken(data.accessToken);
            this.resetearQR();
          } else if (data['tfa'] === "disabled") {
            this.tokenStorage.saveToken(data.accessToken);
            this.loginTfaDisabled();
          } else if (data['tfa'] !== "disabled") {
            this.form.controls['totpkey'].addValidators([Validators.required, Validators.minLength(6)])
            this.submitted = false;
            this.tfaFlag = true;
          }
        },
        error: (error) => {
          console.error(error);

          if (error.error.status == 650) {
            this._notificationI18n.error('NOTIFICATION.MESSAGE.DATOS_DE_ACCESO_INVALIDOS', 50000);
          }
          else if(error.error.status == 651){
            this._notificationI18n.errorRedir(
              'COMMON.NOTIFICATION.ERROR',
              'LOGIN.ERROR.USER_DEACTIVATED',
              50000,
              'LOGIN.ERROR.REACTIVATE_LINK',
              '../forgot-password'
            );
          }
          this.isLoginFailed = true;
        },
      });
    }
  }

  logout(): void {
    this.tokenStorage.signOut();
    window.location.reload();
  }

  loginTfaEnabled(): any {
    this.submitted = true;

    if (this.form.get('totpkey').hasError('minlength')) {
      this._notificationI18n.error('NOTIFICATION.MESSAGE.EL_CODIGO_DEBE_CONTENER_6_CARACTERES', 5000);
      return false;
    }

    if (!this.form.valid) {
      this._notificationI18n.warning('NOTIFICATION.MESSAGE.RELLENE_TODOS_LOS_CAMPOS_POR_FAVOR', 5000);
      return false;
    }
    this.authService.login(this.form.controls['email'].value, this.form.controls['password'].value, this.form.controls['totpkey'].value)
      .pipe(takeUntil(this.destroy$))
      .subscribe({
      next: (dataTotpkey) => {
        if (dataTotpkey.codigoError !== "INVALID_2FA") {
          this.tokenStorage.saveToken(dataTotpkey.accessToken);
          this.authService.updateAuthStatus(true);
          this.userService.getCurrentUserFromServer()
            .pipe(takeUntil(this.destroy$))
            .subscribe({
            next: (data) => {
              this.tokenStorage.setUser(data.Usuario, data.usuarioRepresenta);
              this.raiz.reloadHeader = !this.raiz.reloadHeader;
              if (this.environment == 'novotaxi') {
                this.router.navigateByUrl('/admin-novotaxi').then(() => {
                  this.router.navigate(['admin-novotaxi']);
                });
              } else {
                this.router.navigateByUrl(this.returnUrl);
              }
            },
            error: (error) => {
              //TODO error
            }
          })
        } else {
          this._notificationI18n.error('NOTIFICATION.MESSAGE.EL_CODIGO_NO_ES_CORRECTO', 5000);
          this.form.controls['totpkey'].setErrors({ 'incorrect': true });
        }
      },
      error: (err) => {
        this.errorMessage = err.error.message;
        this.isLoginFailed = true;
      },
    })
  }

  loginTfaDisabled(): any {
    this.isLoggedIn = true;
    this.isLoginFailed = false;
    this.authService.updateAuthStatus(true);
    this.userService.getCurrentUserFromServer()
      .pipe(takeUntil(this.destroy$))
      .subscribe({
      next: (data) => {
        this.tokenStorage.setUser(data.Usuario, data.usuarioRepresenta);
        this.raiz.reloadHeader=!this.raiz.reloadHeader;
        if (this.environment == 'novotaxi') {
          this.router.navigateByUrl('/admin-novotaxi').then(() => {
            this.router.navigate(['admin-novotaxi']);
          });
        } else {
          this.router.navigateByUrl(this.returnUrl);
        }
      },
      error: (error) => {

      }
    })

  }

  resetearQR(): any {
    this.resetQR = true;
    this.pedirQR();
    //this.guardarQR();
  }

  qr;
  pedirQR(): any {
    this.submitted = false;
    this.authService.pedirQr()
      .pipe(takeUntil(this.destroy$))
      .subscribe({
      next: (data) => {

        this.qr = data;

      },
      error: (err) => {

        console.error(err);
      }
    });
  }

  guardarQR(): any {
    this.submitted = true;

    if (this.form2.get('totpkey').hasError('minlength')) {
      this._notificationI18n.error('NOTIFICATION.MESSAGE.EL_CODIGO_DEBE_CONTENER_6_CARACTERES', 5000);
      return false;
    }

    if (!this.form2.valid) {
      this._notificationI18n.warning('NOTIFICATION.MESSAGE.FALTAN_CAMPOS_POR_RELLENAR', 50000);
    } else {
      this.authService.guardarQR(this.qr.secret, this.form2.get('totpkey').value)
        .pipe(takeUntil(this.destroy$))
        .subscribe({
        next: (data) => {
          this.qr = data;
          if (this.qr.result === "success") {
            this.tfActivated = true;
            this.errorQR = false;
            this.resetedQR = true;
            this.authService.updateAuthStatus(true);
            this.userService.getCurrentUserFromServer()
              .pipe(takeUntil(this.destroy$))
              .subscribe({
              next: (data) => {

                this.tokenStorage.setUser(data.Usuario, data.usuarioRepresenta);
                this.raiz.reloadHeader = !this.raiz.reloadHeader;
                this.router.navigateByUrl(this.returnUrl);
              },
              error: (error) => {

              }
            })
          } else {
            this.form2 = this.formBuilder.group({
              totpkey: [""]
            });
            this.errorQR = true;
          }
        },
        error: (error) => {
          if (error.error.codigo == 637) {
            this._notificationI18n.error('NOTIFICATION.MESSAGE.CODIGO_INCORRECTO', 50000);
          }
        }
      });
    }
  }
  redireccion(): void {
    this._claveservice.getSamlRequest()
      .pipe(takeUntil(this.destroy$))
      .subscribe({
      next: async (data: SamlRequest) => {
        this.post(data.nodeService, {
          SAMLRequest: data.SamlRequest,
          RelayState: data.RelayState,
        });
      },
    });
  }

  

  post(path: string, params: any): void {
    let method = "post";
    var form = document.createElement("form");
    form.setAttribute("method", method);
    form.setAttribute("action", path);
    for (var key in params) {
      if (params.hasOwnProperty(key)) {
        var hiddenField = document.createElement("input");
        hiddenField.setAttribute("type", "hidden");
        hiddenField.setAttribute("name", key);
        hiddenField.setAttribute("value", params[key]);
        form.appendChild(hiddenField);
      }
    }
    document.body.appendChild(form);
    form.submit();
  }
}

